import { useCallback, useState } from 'react';

export const usePagination = (items, pageSize) => {
  if (!Number.isInteger(pageSize) || pageSize < 1) throw new Error('pageSize must be a positive integer');
  const [page, setPage] = useState(0);
  const totalPages = Math.max(1, Math.ceil(items.length / pageSize));
  const lastPage = totalPages - 1;
  const currentPage = Math.min(page, lastPage);
  // "previous" is the updater's current-state argument, never an outer closure.
  // React's setPage is stable; lastPage is the only captured reactive value.
  const nextPage = useCallback(() => setPage(previous => Math.min(previous + 1, lastPage)), [lastPage]);
  const previousPage = useCallback(() => setPage(previous => Math.max(0, Math.min(previous, lastPage) - 1)), [lastPage]);
  return {
    currentPage,
    totalPages,
    pageItems: items.slice(currentPage * pageSize, (currentPage + 1) * pageSize),
    nextPage,
    previousPage,
  };
};